import { render, staticRenderFns } from "./section-empresa.vue?vue&type=template&id=1d594ff5&scoped=true"
var script = {}
import style0 from "./section-empresa.vue?vue&type=style&index=0&id=1d594ff5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d594ff5",
  null
  
)

export default component.exports